"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuatorWrapper$ = exports.ValuatorWrapper$outboundSchema = exports.ValuatorWrapper$inboundSchema = void 0;
exports.valuatorWrapperToJSON = valuatorWrapperToJSON;
exports.valuatorWrapperFromJSON = valuatorWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.ValuatorWrapper$inboundSchema = z.object({
    id: z.string(),
    price: z.string(),
});
/** @internal */
exports.ValuatorWrapper$outboundSchema = z.object({
    id: z.string(),
    price: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ValuatorWrapper$;
(function (ValuatorWrapper$) {
    /** @deprecated use `ValuatorWrapper$inboundSchema` instead. */
    ValuatorWrapper$.inboundSchema = exports.ValuatorWrapper$inboundSchema;
    /** @deprecated use `ValuatorWrapper$outboundSchema` instead. */
    ValuatorWrapper$.outboundSchema = exports.ValuatorWrapper$outboundSchema;
})(ValuatorWrapper$ || (exports.ValuatorWrapper$ = ValuatorWrapper$ = {}));
function valuatorWrapperToJSON(valuatorWrapper) {
    return JSON.stringify(exports.ValuatorWrapper$outboundSchema.parse(valuatorWrapper));
}
function valuatorWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ValuatorWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ValuatorWrapper' from JSON`);
}
//# sourceMappingURL=valuatorwrapper.js.map